export default __webpack_public_path__ + "static/bed-bath-beyond-9-a-e2c6de4a7511ea3e7a8bf64d11b4264c.webp";